import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { map, Observable, shareReplay } from "rxjs";
import { ReleaseTypeResource } from "../models/release-type-resource.model";
import { ReleaseTypesResource } from "../models/release-types-resource.model";

@Injectable({ providedIn: "root" })
export class ReleaseTypesService {
    private readonly httpClient = inject(HttpClient);

    private releaseTypes$ = this.httpClient.get<ReleaseTypesResource>("/api/releaseTypes").pipe(
        map((res) => res.releaseTypes ?? res.items ?? []),
        shareReplay(1)
    );

    public getReleaseTypes$(): Observable<Array<ReleaseTypeResource>> {
        return this.releaseTypes$;
    }
}
